import { combineReducers } from 'redux';

import loading from './loading';
import page from './page';
import searching from './searching';

/**
 * @typedef {{
 *    loading: import('./loading').UserUiSelectLoadingReducer,
 *    searching: import('./searching').UserUiSelectSearchingReducer,
 *    page: Record<string, { page: import('modules/global/generic.types').Page, hasMore: boolean }>,
 * }} UserUiSelectReducer
 */

export default combineReducers({
  loading,
  searching,
  page,
});
